"use client"

import ClientOnly from "@/components/ClientOnly"
import { msalConfig } from "@/lib/msalConfig"
import { Configuration, PublicClientApplication } from "@azure/msal-browser"
import { MsalProvider } from "@azure/msal-react"
import { Toaster } from "sonner"

const msalInstance = new PublicClientApplication(msalConfig as Configuration)

export default function PublicProviders({
  children,
}: {
  children: React.ReactNode
}) {
  // Service Worker registration is now handled by PWAProvider
  // Removed duplicate registration to avoid conflicts

  return (
    <MsalProvider instance={msalInstance}>
      {children}
      <Toaster position="top-center" />
      <ClientOnly>{null}</ClientOnly>
    </MsalProvider>
  )
}
